import { useEffect } from 'react';

/**
 * PageSEO — Sets document title and meta tags for non-blog pages.
 * Drop into any page component: <PageSEO title="..." description="..." />
 */
export default function PageSEO({ title, description, path, noindex }) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    const url = `https://rentual.co${path || window.location.pathname}`;
    const metas = [];

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
        metas.push(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', url);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Rentual');
    setMeta('name', 'twitter:card', 'summary');
    setMeta('name', 'twitter:title', title);
    setMeta('name', 'twitter:description', description);

    if (noindex) {
      setMeta('name', 'robots', 'noindex, nofollow');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    return () => {
      document.title = prevTitle;
      metas.forEach(el => el.remove());
    };
  }, [title, description, path, noindex]);

  return null;
}
